import React, {useEffect, useState} from "react";
import DataTable from "react-data-table-component";
import {useDispatch, useSelector} from "react-redux";
import {Link, useRouteMatch} from "react-router-dom";
import ApiConnect from "../../../../Utils/ApiConnect";
import DeletePop from "../../../Components/DeletePop";
import FileViewer from "../../../Components/FileViewer";
import EditProduct from "./EditCategory";

export default function ViewCategory() {
  const categoryList = useSelector((state) => state.Inventory.Category);
  const { url } = useRouteMatch();
  const dispatch = useDispatch();
  const [selectedId, SetselectedId] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [showModal, Setmodal] = useState(false);
  const [selectedFile, SetselectedFile] = useState(false);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchHandler();
  }, []);
  const columns = [
    {
      name: "Category Name",
      selector: row => row.name,
      sortable: true,
      cell: (row) => {
        return (
          <div className="media d-inline-flex">
            <img
              className="avatar avatar-lg"
              src={row.image}
              alt={row.name}
              onClick={() => {
                SetselectedFile(row.image);
                Setmodal(true);
              }}
            />
            <div className="media-body">
              <p className="lh-1">{row.name}</p>
              <small>{row.catid}</small>
            </div>
          </div>
        );
      },
    },
    {
      name: "Total Product",
      selector: row => row.product,
      sortable: true,
    },
    {
      name: "Web Publish",
      selector: row => row.webview,
      cell: (row) => {
        return (
          <React.Fragment>
            <span
              className={`material-icons-outlined ${
                row.webview === "1" ? "text-success" : ""
              }`}
            >
              public
            </span>
          </React.Fragment>
        );
      },
    },
    {
      name: "Place",
      selector: row => row.bar,
      cell: (row) => {
        return (
          <React.Fragment>
            <span
              className={`material-icons-outlined ${
                row.bar === "1" ? "text-success" : ""
              }`}
            >
              local_bar
            </span>
            <span
              className={`material-icons-outlined ${
                row.kitchen === "1" ? "text-success" : ""
              }`}
            >
              kitchen
            </span>
          </React.Fragment>
        );
      },
    },
    {
      name: "Action",
      selector: row => row.action,
      className: "table-actions",
      width: "150px",
      sortable: false,
      cell: (row) => {
        return (
          <React.Fragment>
            <button
              className="table-action btn btn-square btn-pure hover-info"
              onClick={() => <EditProduct product={row} />}
            >
              <span className="material-icons-outlined">visibility</span>
            </button>
            <Link
              className="table-action btn btn-square btn-pure hover-warning"
              to={`${url}/Edit/${row.catid}`}
            >
              <span className="material-icons-outlined">edit_note</span>
            </Link>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(row.id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
    ];

  const customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  const filteredData = categoryList.filter(
    item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(filterText.toLowerCase())
      )
  );

  const fetchHandler = () => {
    ApiConnect.get("/Module/Inventory/Category/Details")
      .then((response) => {
        let Category = response.data;
        dispatch({ type: "SET_INVENTORY_CATEGORY", payload: { Category } });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const SetviewerTrigger = () => {
    Setmodal(false);
  };
  return (
    <div className="container">
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => setFilterText(e.target.value)}
                />
              </div>
              <DataTable
                className="table table-separated"
                keyField="id"
                columns={columns}
                data={filteredData}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={customStyles}
                filter
                exportable
              />
            </div>
            <DeletePop
              trigger={triggerModal}
              delUrl={`/Module/Inventory/Category/Delete?id=${selectedId}`}
              hideTrigger={SettriggerModal}
              fallAction={fetchHandler}
            />
            <FileViewer
              trigger={showModal}
              doc={selectedFile}
              hideTrigger={SetviewerTrigger}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
